export const TitleEllipsis = (input) => (input.length > 42 ? `${input.substring(0, 42)}...` : input)
export const BodyEllipsis = (input) => (input.length > 110 ? `${input.substring(0, 110)}...` : input)
